import "@/index.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Tokens from "@/pages/Tokens";
import Scans from "@/pages/Scans";
import ScanDetail from "@/pages/ScanDetail";
import Downloads from "@/pages/Downloads";
import Simulator from "@/pages/Simulator";
import Sessions from "@/pages/Sessions";
import SessionDetail from "@/pages/SessionDetail";
import Clients from "@/pages/Clients";

function Protected({ children, adminOnly = false }) {
  const { user, checking } = useAuth();
  if (checking || user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#070B14] text-slate-500 font-mono text-sm">
        Authenticating…
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  return <Layout>{children}</Layout>;
}

function LoginRoute() {
  const { user, checking } = useAuth();
  if (checking) return null;
  if (user) return <Navigate to="/" replace />;
  return <Login />;
}

function App() {
  useEffect(() => {
    const blockContextMenu = (e) => e.preventDefault();
    document.addEventListener("contextmenu", blockContextMenu);
    return () => document.removeEventListener("contextmenu", blockContextMenu);
  }, []);

  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginRoute />} />
          <Route path="/scan/:token" element={<Simulator />} />
          <Route path="/" element={<Protected><Dashboard /></Protected>} />
          <Route path="/tokens" element={<Protected><Tokens /></Protected>} />
          <Route path="/scans" element={<Protected><Scans /></Protected>} />
          <Route path="/scans/:id" element={<Protected><ScanDetail /></Protected>} />
          <Route path="/sessions" element={<Protected><Sessions /></Protected>} />
          <Route path="/sessions/:id" element={<Protected><SessionDetail /></Protected>} />
          <Route path="/clients" element={<Protected adminOnly><Clients /></Protected>} />
          <Route path="/downloads" element={<Protected><Downloads /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
